import { PROCESS_TYPES, TEMPLATE_TYPES, TEMPLATES } from "utils/constants";
import Contact from "./Contact";
import Default from "./Default";
import Quote from "./Quote";
import QuoteSent from "./QuoteSent";
import SelectProducts from "./SelectProducts";

const lfThemes =
  TEMPLATES[PROCESS_TYPES.B2B].THEMES[TEMPLATE_TYPES.B2B_LAFOURGALE];

const Templates = {
  [lfThemes.CONTACT]: Contact,
  [lfThemes.SELECT_PRODUCTS]: SelectProducts,
  [lfThemes.QUOTE]: Quote,
  [lfThemes.QUOTE_SENT]: QuoteSent,
  default: Default,
};

export default Templates;
